document.addEventListener('DOMContentLoaded', function () {
  // Initialize Swiper for each card slider
  document.querySelectorAll('.card-slider').forEach((slider, index) => {
    const blockType = slider.id; // Identify each block by its unique ID

    // Initialize the main card swiper for each block type
    new Swiper(`#${blockType}`, {
      loop: false,
      slidesPerView: 1.2, // Number of visible cards at a time (adjust as needed)
      spaceBetween: 20,
      pagination: {
        el: `#${blockType} .swiper-pagination`,
        clickable: true,
      },
      keyboard: {
        enabled: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 2.3,
          spaceBetween: 25,
        },
        1024: {
          slidesPerView: 3.4,
          spaceBetween: 25,
        },
        1440: {
          slidesPerView: 5.4,
          spaceBetween: 25,
        },
      },
      navigation: {
        nextEl: `#${blockType} .swiper-button-next`,
        prevEl: `#${blockType} .swiper-button-prev`,
      },
    });

   

    document.querySelectorAll('.popup-hero-slider').forEach((popupSlider) => {
  const blockType = popupSlider.getAttribute('data-block'); // Get block type (e.g., 'projekte')
  const sliderIndex = parseInt(popupSlider.id.split('-').pop()); // Get the numeric index of the slider
  const popupId = `popup-${blockType}-${sliderIndex}`;
  const currentPopup = document.getElementById(popupId);
  const nextPopupId = `popup-${blockType}-${sliderIndex + 1}`;
  const nextPopup = document.getElementById(nextPopupId);

  // Find the corresponding thumbnail slider
  const thumbsSlider = document.querySelector(`#thumbs-slider-${blockType}-${sliderIndex}`);

  // Initialize the thumbnail slider if it exists
  const thumbsSwiper = thumbsSlider
    ? new Swiper(thumbsSlider, {
        spaceBetween: 10,
        slidesPerView: 4.2,
      keyboard: {
        enabled: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 5.3,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 7.4,
          spaceBetween: 10,
        },
        1440: {
          slidesPerView: 9.4,
          spaceBetween: 10,
        },
      },
        freeMode: true,
        watchSlidesProgress: true,
      })
    : null;

  // Initialize the hero slider
  const heroSwiper = new Swiper(popupSlider, {
    spaceBetween: 10,
    navigation: {
      nextEl: `.hero-next-${blockType}-${sliderIndex}`,
      prevEl: `.hero-prev-${blockType}-${sliderIndex}`,
    },
    thumbs: {
      swiper: thumbsSwiper,
    },
  });
});
  });
});
